import React from 'react'
import {Stack} from '@mui/material';
import UserFillIcon from 'src/assets/icons/user-fill-icon';

export default function UserIcon({size = '32'}) {
  return (
    <Stack sx={{
      width: `${size}px`,
      height: `${size}px`,
      backgroundColor: '#F4F6F8',
      borderRadius: '8px'
    }}
      alignItems='center'
      justifyContent='center'
    >
      <UserFillIcon sx={{width: '16px', height: '16px'}} />
    </Stack>
  )
}

